import * as MAP_ACTION from 'js/constant/action/map'
import { createAction } from 'redux-actions'
import { getFile } from 'js/helper/http'
import { getData } from 'js/redux/api/map'
import _ from 'lodash'

const updateLoader = createAction(MAP_ACTION.UPDATE_MAP_LOADER)
const updateCoordinatesData = createAction(MAP_ACTION.UPDATE_COORDINATES_DATA)
const updateLocationModal = createAction(MAP_ACTION.UPDATE_LOCATION_MODAL)
const updateSelectedPostcode = createAction(MAP_ACTION.UPDATE_SELECTED_POSTCODE)
const updateLocationFocus = createAction(MAP_ACTION.UPDATE_LOCATION_FOCUS)

export const getCoordinates =
    () =>
      async (dispatch, getState, { map }) => {
        dispatch(updateLoader(true))
        const url = await getData()
        const coordinates = await getFile(url)

        if (coordinates) {
          dispatch(updateCoordinatesData(coordinates))
          dispatch(updateLoader(false))
        } else {
          dispatch(updateLoader(false))
          console.log('error loading coordinates')
        }
        dispatch(updateLoader(false))
      }

export const getLocationModal = (bool, postcode) => (dispatch) => {
  dispatch(updateSelectedPostcode(postcode))
  dispatch(updateLocationModal(bool))
}

export const openLocationModal = (bool) => (dispatch) => {
  dispatch(updateLocationModal(bool))
}

export const getLocationFocus =
    (postcode) =>
      async (dispatch, getState, { map }) => {
        try {
          const { map: { coordinatesData } } = await getState()
          dispatch(updateLoader(true))
          if (_.isEmpty(coordinatesData)) {
            const url = await getData()
            const data = await getFile(url)
            const coordinates = await data.filter(item => item.postcode === postcode)
            if (coordinates) {
              dispatch(
                updateSelectedPostcode(...coordinates)
              )
              dispatch(updateLocationFocus(...coordinates))
              dispatch(updateLoader(false))
            }
          } else {
            const coordinates = await coordinatesData.filter(item => item.postcode === postcode)
            if (coordinates) {
              dispatch(
                updateSelectedPostcode(...coordinates)
              )
              dispatch(updateLocationFocus(...coordinates))
              dispatch(updateLoader(false))
            }
          }
        } catch (error) {
          dispatch(updateLoader(false))
          console.log('Error', error)
        }
      }

export const unsetLocationFocus = () => async (dispatch) => {
  dispatch(updateSelectedPostcode(false))
}
